import Modal from "react-bootstrap/Modal";

import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { apiEditCustomer } from "../../../api/master";
// import { apiCity, apiState } from "../../../api/stateAndCity";
import customerSchema from "../../../validations/customer";
import { inputOnlyNumber } from "../../../utils";

function CompanyEdit(props) {
  // const [stateValue, setStateValue] = useState([]);
  // const [city, setCity] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);

  // async function getStateAndCity() {
  //   await apiState().then((result) => setStateValue(result.data.data.list));
  //   await apiCity({paginate: 0}).then((result) => setCity(result?.data?.data?.list));
  // }

  // useEffect(function () {
  //   getStateAndCity();
  // }, []);

  const companyFormik = useFormik({
    initialValues: {
      cust_id: props?.id?.cust_id,
      customer_name: props.id?.customer_name,
      cust_address: props.id?.cust_address,
      customer_mobile: props.id?.customer_mobile,
      // cust_state_id: props.id?.cust_state_id,
      // cust_city_id: props.id?.cust_city_id,
      // cust_pincode: props.id?.cust_pincode,
    },

    validationSchema: customerSchema.validateCompanyEdit(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      values = {
        cust_id: values?.cust_id,
        cust_address: values.cust_address,
        customer_name: values.customer_name,
        customer_mobile: values.customer_mobile,
        // cust_state_id: Number(values.cust_state_id),
        // cust_city_id: Number(values.cust_city_id),
        // cust_pincode: Number(values.cust_pincode)
      };
      setIsSubmit(true);
      await apiEditCustomer(values)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });

  console.log("companyFormikcompanyFormik",companyFormik.errors)

  // const stateListMap = stateValue?.flatMap((el) => {
  //   return {
  //     value: el?.state_id,
  //     label: el.name,
  //   };
  // });

  // let filterCityName = city?.filter(
  //   (el) => Number(el?.state_id) === Number(companyFormik.values.cust_state_id)
  // );

  // const cityListMap = filterCityName?.flatMap((el) => {
  //   return {
  //     value: el?.city_id,
  //     label: el.city,
  //   };
  // });

  useEffect(function () {}, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit Customer
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={companyFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="customer_name">
              Customer Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="customer_name"
              {...companyFormik.getFieldProps("customer_name")}
            />
            {companyFormik.errors.customer_name && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.customer_name}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="customer_mobile">Mobile No</label>
            <input
              type="text"
              onKeyDown={inputOnlyNumber}
              maxLength={13}
              className="form-control"
              id="customer_mobile"
              {...companyFormik.getFieldProps("customer_mobile")}
            />
            {companyFormik.errors.customer_mobile && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.customer_mobile}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="cust_address">Customer Address</label>
            <textarea
              type="text"
              maxLength={100}
              className="form-control"
              id="cust_address"
              {...companyFormik.getFieldProps("cust_address")}
            />
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="cust_state_id">
              State <span className="text-danger">*</span>
            </label>
            <select
            name="select"
              className="form-select"
              id="cust_state_id"
              {...companyFormik.getFieldProps("cust_state_id")}
            >
              <option hidden>Select...</option>
              {stateListMap?.map((list) => (
                <option value={list.value}>{list.label}</option>
              ))}
            </select>
            {companyFormik.errors.cust_state_id && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_state_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="city_id">
              City <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="city_id"
              {...companyFormik.getFieldProps("cust_city_id")}
            >
              <option hidden>Select...</option>
              {cityListMap?.map((list) => (
                <option value={list.value} selected={props?.id?.cust_city_id === list.value}>{list.label}</option>
              ))}
            </select>
            {companyFormik.errors.cust_city_id && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_city_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="cust_pincode">
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={9}
              className="form-control"
              id="cust_pincode"
              {...companyFormik.getFieldProps("cust_pincode")}
            />
            {companyFormik.errors.cust_pincode && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_pincode}
              </div>
            ) : null}
          </div> */}
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="button"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  onClick={() => {
                    companyFormik.resetForm();
                    setShownew(false);
                    setSuccess("");
                  }}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default CompanyEdit;
